import { loadable } from '@fiverr-private/perseus';

const DmBriefCreationTextArea = loadable(
    () => import(/* webpackChunkName: "DmBriefCreationTextArea" */ './DmBriefCreationTextArea')
);

export const DM_BRIEF_CREATION_CONFIG = {
    components: [
        {
            component: DmBriefCreationTextArea,
            options: {
                name: 'DM Brief Creation Text Area',
                inputs: [
                    {
                        name: 'source',
                        type: 'text',
                        required: true,
                        defaultValue: 'Builder.io Page',
                    },
                    {
                        name: 'isDefaultHourly',
                        type: 'boolean',
                        required: false,
                        defaultValue: false,
                    },
                    {
                        name: 'autoSubmitOnSignUp',
                        type: 'boolean',
                        required: false,
                        defaultValue: false,
                    },
                    {
                        name: 'predefinedTags',
                        type: 'list',
                        subFields: [
                            { name: 'title', type: 'text', required: true },
                            { name: 'prompt', type: 'text', required: true },
                        ],
                        helperText: 'Predefined prompt tags shown below the text area',
                    },
                ],
                defaults: {
                    bindings: {
                        'component.options.currencyObject': 'state.contextData.currencyObject',
                    },
                },
            },
        },
    ],
};
